import type { CreateContractDTO, UpdateContractDTO } from "./contracts";

/** Same rules as ContractForm: employment-related type names in Lao. */
export function isEmploymentContractTypeName(
  name: string | null | undefined,
): boolean {
  if (!name) return false;
  const n = name.trim();
  return (
    n.includes("ຈ້າງ") ||
    n.includes("ພະນັກງານ") ||
    n.includes("ແຮງງານ")
  );
}

export function normalizeCreateContractForTypeName(
  typeName: string,
  input: CreateContractDTO,
): CreateContractDTO {
  if (isEmploymentContractTypeName(typeName)) {
    return {
      ...input,
      customerId: null,
      quotationDocumentId: null,
      autoRenewal: false,
    };
  }
  return {
    ...input,
    employeeId: null,
  };
}

export function normalizeUpdateContractForTypeName(
  typeName: string,
  input: UpdateContractDTO,
): UpdateContractDTO {
  if (isEmploymentContractTypeName(typeName)) {
    return {
      ...input,
      customerId: null,
      quotationDocumentId: null,
      autoRenewal: false,
    };
  }
  return {
    ...input,
    employeeId: null,
  };
}
